import _ from 'lodash';

export function convertOrganizationToBranch({ organization, deliveryString, takeoutString, baseLocation }) {
  const deliveryTypes = [];

  const deliveryInfos = organization.deliveryInfos || [];
  const hasDelivery = Boolean(deliveryInfos.find(di => di.type === 'delivery'));
  const hasTakeout = Boolean(deliveryInfos.find(di => di.type === 'takeout'));

  const address = _.get(organization, 'address.formatted') || '';

  if (hasDelivery) {
    deliveryTypes.push(deliveryString);
  }

  if (hasTakeout) {
    deliveryTypes.push(takeoutString);
  }

  let distance, formattedDistance;
  try {
    distance = getDistanceFromLatLonInKm(baseLocation.latLng || baseLocation, organization.address.latLng);
    formattedDistance = formatDistance(distance);
  } catch (e) {
    distance = 0;
    formattedDistance = '';
  }
  return {
    id: organization.id,
    title: organization.title[organization.locale],
    address,
    latLng: organization.address ? organization.address.latLng : undefined, //todo masha check why some mocks have it undefined
    deliveryTypes,
    distance,
    formattedDistance,
  };
}

const EARTH_RADIUS_IN_METERS = 6371000;

function degreesToRadians(deg) {
  return deg * (Math.PI / 180);
}

function getDistanceFromLatLonInKm(source, destination) {
  const latDifference = degreesToRadians(destination.lat - source.lat) / 2;
  const lngDifference = degreesToRadians(destination.lng - source.lng) / 2;

  const temp =
    Math.sin(latDifference) * Math.sin(latDifference) +
    Math.cos(degreesToRadians(source.lat)) *
      Math.cos(degreesToRadians(destination.lat)) *
      Math.sin(lngDifference) *
      Math.sin(lngDifference);

  const distance = 2 * Math.atan2(Math.sqrt(temp), Math.sqrt(1 - temp));
  return Math.round(EARTH_RADIUS_IN_METERS * distance);
}

export function formatDistance(meters, unit = 'meters') {
  if (!_.isNumber(meters)) {
    return '';
  }

  if (unit === 'miles') {
    return ((meters / 1000) * 0.62).toFixed(2).replace(/.00$/, '') + 'ml';
  }

  if (meters >= 1000) {
    return (meters / 1000).toFixed(1).replace(/.0$/, '') + 'km';
  }

  return meters + 'm';
}
